import { Icons } from "assets/icons";
import FilterBar from "components/common/FilterBar";
import NoDataFound from "components/common/NoDataFound";
import Paginations from "components/common/Paginations";
import DataTable from "components/common/table/DataTable";
import { usePermission } from "hooks/usePermission";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatUTCDate } from "utils/utils";

const STATIC_BARRIER_LOGS = [
  {
    _id: "barrier_001",
    gate: "Interior",
    reason: "Vehicle Malfunction",
    vehicleNumber: "ABC-1234",
    description: "Vehicle granted access after successful plan verification",
    staff: "Ali Hassan",
    timestamp: "2025-03-25T10:05:00Z",
  },
  {
    _id: "barrier_002",
    gate: "Exterior",
    reason: "Customer Request",
    vehicleNumber: "XYZ-5678",
    description: "Staff manually opened barrier due to sensor malfunction",
    staff: "Priya Nair",
    timestamp: "2025-03-26T14:22:00Z",
  },
  {
    _id: "barrier_003",
    gate: "Interior",
    reason: "Safety Hazard",
    vehicleNumber: "LMN-9012",
    description: "Vehicle not registered under any active membership plan",
    staff: "System",
    timestamp: "2025-03-27T09:00:00Z",
  },
  {
    _id: "barrier_004",
    gate: "Exterior",
    reason: "Wrong Turn",
    vehicleNumber: "PQR-3456",
    description: "Barrier blocked — membership plan expired 2 days ago",
    staff: "Ali Hassan",
    timestamp: "2025-03-28T16:45:30Z",
  },
  {
    _id: "barrier_005",
    gate: "Interior",
    reason: "Vehicle Malfunction",
    vehicleNumber: "DEF-7890",
    description: "Customer used monthly free wash entitlement",
    staff: "Sara Ahmed",
    timestamp: "2025-03-29T08:10:00Z",
  },
];

const BarrierControlLogs = () => {
  const { t } = useTranslation();
  const { noPlans } = Icons || {};
  const { canAction } = usePermission();
  const { canView } = canAction("vehicles");

  const [keyword, setKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const filtered = STATIC_BARRIER_LOGS.filter(
    (log) =>
      log.gate.toLowerCase().includes(keyword.toLowerCase()) ||
      log.reason.toLowerCase().includes(keyword.toLowerCase()) ||
      log.vehicleNumber.toLowerCase().includes(keyword.toLowerCase()) ||
      log.staff.toLowerCase().includes(keyword.toLowerCase())
  );

  const columns = useMemo(
    () => [
      {
        header: t("Gate"),
        key: "gate",
        render: (value) => <strong>{value}</strong>,
      },
      {
        header: t("Reason"),
        key: "reason",
      },
      {
        header: t("Vehicle Number"),
        key: "vehicleNumber",
        render: (value) => <div className="ltr_text">{value}</div>,
      },
      {
        header: t("Description"),
        key: "description",
        render: (value) => <div className="text-muted small">{value}</div>,
      },
      {
        header: t("Staff"),
        key: "staff",
      },
      {
        header: t("Date & Time"),
        key: "timestamp",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
    ],
    [t]
  );

  if (!canView) return null;

  return (
    <div className="page-content addons_page">
      <h4 className="page_title mb-3">{t("Barrier Control Logs")}</h4>
      <FilterBar
        keyword={keyword}
        setKeyword={setKeyword}
        keywordPlaceholder={t("Search by gate, reason, vehicle or staff")}
        filters={[]}
        selectedFilters={{ keyword }}
        onSearch={() => {}}
        onReset={() => setKeyword("")}
        isBtn={false}
        isDateRange={false}
      />

      {filtered.length === 0 && (
        <NoDataFound title={t("No barrier logs found")} icon={noPlans} />
      )}

      {filtered.length > 0 && (
        <>
          <DataTable columns={columns} data={filtered} t={t} />
          <Paginations
            currentPage={currentPage}
            totalPages={1}
            totalCount={filtered.length}
            onPageChange={setCurrentPage}
          />
        </>
      )}
    </div>
  );
};

export default BarrierControlLogs;